
    import { Template } from '@swc-packages-internal/contextual-help/stories/template.js';
    import { render } from 'lit';
    const demo = document.querySelector('.demo-preview');
    const config = document.querySelector('.demo-config');
    function getArgs() {
        const args = {};
        if (!config) {
            return args;
        }
        const form = config.querySelectorAll('.demo-control');
        form.forEach(arg => {
            args[arg.id] = arg.value === 'false' ? false : arg.value;
        })
        return args;
    }
    const renderDemo = (args = {}) => {
        // Pass componentName to Template for variant detection
        args.componentName = 'contextual-help';
        render(Template(args), demo);
    };
    if (config) {
        config.addEventListener('change', () => {
            renderDemo(getArgs());
        });
    }
    customElements.whenDefined('sp-picker').then(() => {
        const defaultArgs = getArgs();
        console.log(defaultArgs);
        renderDemo(defaultArgs);
    });
